import { useEffect, useState } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'device-token';

export function useDeviceToken() {
    const [deviceToken, setDeviceToken] = useState<string | null>(null);

    useEffect(() => {
        async function loadDeviceToken() {
            try {
                const fp = await FingerprintJS.load();
                const result = await fp.get();

                const currentToken = result.visitorId;
                const storedToken = localStorage.getItem(STORAGE_KEY);

                if (storedToken === currentToken) {
                    setDeviceToken(storedToken);
                } else {
                    localStorage.setItem(STORAGE_KEY, currentToken);
                    setDeviceToken(currentToken);
                }
            } catch (error) {
                console.error('Erro ao gerar DeviceToken:', error);
            }
        }

        loadDeviceToken();
    }, []);

    return deviceToken;
}